import React, { useEffect } from 'react'
import NaveBar from '../composant/NaveHero/NaveBar'
import Footer from '../composant/Footer'
import ServicesSection2 from '../composant/ServicesSection2'
import MainContainerAdhesion2 from '../composant/MainContainerAdhesion2'

const Services = () => {
    // Scroll to top on mount
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div>
       <NaveBar />
      
       
       <ServicesSection2 />
      
       <MainContainerAdhesion2 />
       <Footer />
    </div>
  )
}

export default Services
